@import '../../constants/spacing.module.less';

.drawer-content {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin: @space-24;
  border-radius: 4px;
  background-color: var(--white);
  border: 1px solid var(--default--border-color--12);
}

.form-row {
  padding: @space-16;
  border-bottom: 1px solid var(--default--border-color--12);
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: @space-16;
}

.form-field {
  min-width: 0;
}

.content {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  align-items: stretch;
}

.toolbar {
  padding: @space-16;
  border-bottom: 1px solid var(--default--border-color--12);
}

.editor-area {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.editor-container {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.editor-section {
  min-width: 0;
  height: 100%;
  border-right: 1px solid var(--default--border-color--12);
  overflow: hidden;
}

.preview-section {
  min-width: 0;
  height: 100%;
  overflow: hidden;
}

.preview-toolbar {
  box-sizing: border-box;
  min-height: 49px;
  padding: @space-8 @space-16;
  border-bottom: 1px solid var(--default--border-color--12);
  align-items: center;
  justify-content: space-between;
}

.preview-area {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  background-color: #f5f5f5;
}

.hidden-content {
  visibility: hidden;
  height: 0;
  overflow: hidden;
}

.footer {
  justify-content: space-between;
  padding: @space-24;
  border-top: 1px solid var(--default--border-color--12);
  background-color: var(--white);
}

.state-container {
  flex: 1;
  align-items: center;
  justify-content: center;
}

.loading-container {
  display: flex;
  height: 100%;
  width: 100%;
}

.loading {
  height: 100px;
  margin: auto;
}
